<script>
    import {Line} from 'vue-chartjs'

    const moment = require('moment')

    export default {
        extends: Line,
        props: ['dataProp'],
        data() {
            return {
                options: {
                    scales: {
                        yAxes: [{
                            type: 'logarithmic',
                            ticks: {
                                beginAtZero: true,
                                fontColor: '#414141',
                                drawBorder: false,
                                userCallback: function (label, index, labels) {
                                    if (Math.floor(label) === label) {
                                        return label
                                    }
                                }
                            },
                            gridLines: {
                                display: true
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                display: false
                            }
                        }]
                    },
                    legend: {
                        reverse: true
                    },
                    tooltips: {
                        callbacks: {
                            title: function (tooltipItem, data) {
                                let dayInMonth = new Date().setDate(tooltipItem[0].xLabel)
                                return moment(dayInMonth).format('DD/MM/YYYY')
                            },
                            label: function (tooltipItem, data) {
                                var label = data.datasets[tooltipItem.datasetIndex].label
                                label = label ? (data.labelPrefix + label) : ''
                                if (label) {
                                    label += ': ' + tooltipItem.yLabel
                                }

                                return label
                            }
                        }
                    },
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 5,
                            bottom: 10
                        }
                    },
                    drawBorder: true,
                    responsive: true,
                    maintainAspectRatio: false
                }
            };
        },

        mounted() {
            this.renderChart(this.dataProp, this.options)
        }
    }
</script>